import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import App from "./App";
import { ChakraProvider } from "@chakra-ui/react";

class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            padding: 24,
            fontFamily: "system-ui, sans-serif",
            maxWidth: 560,
            margin: "0 auto",
          }}
        >
          <p style={{ fontWeight: 600 }}>Something went wrong.</p>
          <pre
            style={{
              whiteSpace: "pre-wrap",
              fontSize: 13,
              color: "#c00",
            }}
          >
            {this.state.error.message}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

const container = document.getElementById("root");
if (!container) {
  throw new Error('Missing DOM element with id "root".');
}

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <RootErrorBoundary>
      <ChakraProvider>
        <HashRouter>
          <App />
        </HashRouter>
      </ChakraProvider>
    </RootErrorBoundary>
  </React.StrictMode>
);
